import type { CmpHider } from './types';

export const cookiefirst: CmpHider = {
  id: 'cookiefirst',
  label: 'Cookiefirst',
  css: `
      /* CookieFirst (cookiefirst.com CMP, "by iubenda"): the SDK mounts its entire
         consent UI into a single light-DOM root container ".cookiefirst-root"
         (data-testid="rootContainer", aria-label="Cookie banner") appended to
         <body>. That root holds the consent banner, the fixed full-viewport
         dimming backdrop, the preferences modal, and — after a choice is made (and
         on later visits) — a persistent fixed floating "Privacy settings" cog
         button (span[data-cookiefirst-action="open-preferences"] /
         [data-testid="reopenSettingsBtn"], position:fixed, z-index ~999999910)
         that stays over the page. Hiding ".cookiefirst-root" removes the banner,
         the faded background, the modal, and the floating button in one go; we
         also list the persistent button selectors defensively in case a build
         mounts it outside the root. CookieFirst locks page scroll by setting an
         inline "overflow: hidden" on <html> (and adds a "cf-overflow-hidden" body
         class) while the banner is open; the html/html-body[style*="overflow"]
         release rule above (added for Cookiebot) already out-specifies the inline
         lock, and we add an html-led "cf-overflow-hidden" class release to
         out-specify CookieFirst's own scroll-lock rule injected at runtime. */
      .cookiefirst-root,
      [data-cookiefirst-action="open-preferences"],
      [data-testid="reopenSettingsBtn"] { display: none !important; }
      html body.cf-overflow-hidden {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
